const userno = {
  state: {
    userno: null
  },
  mutations: {
    SET_USERNO: (state,userno) => {
      state.userno = userno
    }
  },
  actions: {
    setUSERNO ({ commit }, userno) {
      commit('SET_USERNO', userno)
    }
  }
}

export default userno
